import React from 'react'

const Footer = () => {
  return (
    <div>
      <footer class='footer'>
        <h4 class='footer-text'>
          &copy;
          <span class='company'>
            <a target="_blank" href='https://omkrjha.netlify.app/'>omkrjha</a>
          </span>
        </h4>
      </footer>
    </div>
  );
}

export default Footer